/**
 * Utility function to get consistent badge styling for campaign statuses
 *
 * @param statusName - The campaign status name (e.g., 'Closed', 'Funded', 'Disbursable')
 * @returns Tailwind CSS classes for the badge
 */
export const getCampaignStatusBadgeClass = (statusName: string | undefined): string => {
    if (!statusName) {
        return 'bg-[#97D7E1]';
    }

    switch (statusName) {
        case 'Unpublished':
        case 'Funded':
        case 'Open':
            return 'bg-primary text-white';
        case 'Inactive':
            return 'bg-whiten';
        case 'Disbursable':
            return 'bg-[#AFC12D]';
        case 'Archived':
            return 'bg-[#F47D29] text-white';
        case 'Closed':
            return 'bg-danger text-white';
        default:
            return 'bg-[#97D7E1]';
    }
};
